<template>
  <div class="mx-10 ma-5">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="errors = null" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Receipt List'"
          :btnName="null"
          :btnColor="'#00B3FF'"
          :btnRoute="null"
          :btnEnable="false"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <template v-if="receipts.length > 0 && hasPermission('receipt.list')">
          <DataTableWithPagination
            :headers="tableHeaders"
            :items="receipts"
            :loading="loading"
            :page="page"
            :total="total"
            @pageChange="page = $event"
          >
            <template #row="{ item, index }">
              <tr
                :class="[
                  { 'first-row': index === 0 },
                  index % 2 === 0 ? 'dark-row' : 'light-row',
                  'custom-row',
                ]"
                @click="viewReceipt(item)"
              >
                <td class="text-left">{{ item.receipt_no }}</td>
                <td class="text-left">
                  {{ formatDate(item.date) }}
                </td>
                <td class="text-left">
                  {{ item.customer ? (item.customer.company_name || (item.customer.first_name + ' ' + item.customer.last_name)) : '-' }}
                </td>
                <td class="text-left">
                  {{ Number(item.amount).toFixed(2) }}
                </td>
                <td class="text-center">
                  <v-chip
                    small
                    :color="item.is_confirmed ? 'green' : 'orange'"
                    text-color="white"
                  >
                    {{ item.is_confirmed ? 'Confirmed' : 'Pending' }}
                  </v-chip>
                </td>
                <td class="text-center">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2"
                        small
                        style="box-shadow: none;"
                      >
                        <v-icon small>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-if="hasPermission('receipt.view')"
                        @click="viewReceipt(item)"
                      >
                        <v-list-item-icon>
                          <v-icon small>mdi-eye</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>View</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </DataTableWithPagination>
        </template>
        <template v-else>
          <v-alert type="info" class="mt-5" outlined>
            No receipts found for the applied filters.
          </v-alert>
        </template>
      </div>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { createNamespacedHelpers, mapGetters as rootMapGetters } from "vuex";
import { useDateFormatter } from "@/composables/useDateFormatter";
const { mapGetters } = createNamespacedHelpers("auth");
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Snackbars from "@/components/shared/Snackbars";
import { InvoiceService } from "@/services/invoice-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "ReceiptGrid",
  components: {
    PageTitleWithSearch,
    Snackbars,
    DataTableWithPagination,
  },
  data: function() {
    return {
      receipts: [],
      page: 1,
      search: "",
      loading: false,
      errors: null,
      snackbar: false,
      successMsg: "",
      headers: [
        { text: "Receipt No", value: "receipt_no", align: "left" },
        { text: "Date", value: "date", align: "left" },
        { text: "Customer", value: "customer", align: "left" },
        { text: "Amount", value: "amount", align: "left", isCurrency: true },
        { text: "Status", value: "is_confirmed", align: "center" },
        { text: "Actions", align: "center" },
      ],
      ...useDateFormatter(),
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    ...rootMapGetters("settings", ["dateFormat", "currencyCode"]),
    tableHeaders() {
      return this.headers.map((h) => {
        if (h.isCurrency) {
          return {
            ...h,
            text: `${h.text} (${this.currencyCode})`,
          };
        }
        return h;
      });
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getReceiptList();
  },
  watch: {
    search() {
      this.page = 1;
      this.getReceiptList();
    },
    page() {
      this.getReceiptList();
    },
  },
  methods: {
    viewReceipt(item) {
      this.$router.push({
        name: "receipt-details",
        params: { uuid: item.uuid },
      });
    },

    getReceiptList() {
      this.loading = true;
      
      InvoiceService.getReceiptList(this.search)
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          if (response.data) {
            this.receipts = response.data;
            console.log(this.receipts);
            this.total = response.data.meta ? response.data.meta.last_page : 1;
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response?.data?.error === 'Empty Results!') {
            this.receipts = [];
          } else {
            this.receipts = [];
            let data = error.response?.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          }
        });
    },

    searchChange(value) {
      this.search = value;
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
